module.exports = __webpack_public_path__ + "img/resource-tech-image-43.d9c4f153.jpg";